import React, { Suspense, useEffect, useState } from 'react';

import { Loader2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import { displayToastError } from '@/helpers';
import { checkIsTempPasswordExpired } from '@/lib/auth';

import { ActivateAccountForm } from '../components/activate-account-form';
import { ExpiredLinkMessage } from '../components/expired-link-message';

export const ActivateAccountPage: React.FC = () => {
  return <ActivateAccountPageContent />;
};

export const ActivateAccountPageContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const tempPassword = searchParams.get('tempPassword') || '';
  const isMember = searchParams.get('isMember') === 'true';
  const [isExpiredLink, setIsExpiredLink] = useState<boolean | null>(null);

  useEffect(() => {
    let isMounted = true;
    if (!email || !tempPassword) {
      setIsExpiredLink(true);
      return;
    }
    checkIsTempPasswordExpired(email, tempPassword)
      .then(res => {
        if (isMounted) {
          setIsExpiredLink(res);
        }
      })
      .catch((error: Error) => {
        if (isMounted) {
          displayToastError(error.message);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [email, tempPassword]);

  const renderContent = () => {
    if (isExpiredLink === null) {
      return (
        <div className="flex h-full items-center justify-center">
          <Loader2 className="animate-spin" />
        </div>
      );
    }
    if (isExpiredLink) {
      return <ExpiredLinkMessage />;
    }
    return <ActivateAccountForm email={email} tempPassword={tempPassword} isMember={isMember} />;
  };

  return (
    <div className="flex min-h-screen flex-1 flex-col items-center justify-center p-8">
      <Suspense fallback={<Loader2 className="animate-spin" />}>{renderContent()}</Suspense>
    </div>
  );
};
